module.exports = __webpack_public_path__ + "assets/img/12_105_big.2d61198d.jpg";